export const AnnouncementSourceTypeEnum = {
    PLATFORM: 'platform',
    ORGANIZER: 'organizer',
} as const;
export type AnnouncementSourceTypeEnum = (typeof AnnouncementSourceTypeEnum)[keyof typeof AnnouncementSourceTypeEnum];
export const AnnouncementStatusEnum = {
    DRAFT: 'draft',
    PUBLISHED: 'published',
} as const;
export type AnnouncementStatusEnum = (typeof AnnouncementStatusEnum)[keyof typeof AnnouncementStatusEnum];
export const AnnouncementTargetEnum = {
    INTERNAL: 'internal',
    EXPONENT_VALIDATED: 'exponent_validated',
    EXPONENT_ALL: 'exponent_all',
} as const;
export type AnnouncementTargetEnum = (typeof AnnouncementTargetEnum)[keyof typeof AnnouncementTargetEnum];
export const BackgroundDisplayEnum = {
    COVER_FIXED: 'cover_fixed',
    COVER_SCROLL: 'cover_scroll',
    COVER_OVERLAY: 'cover_overlay',
    TOP_FADE: 'top_fade',
} as const;
export type BackgroundDisplayEnum = (typeof BackgroundDisplayEnum)[keyof typeof BackgroundDisplayEnum];
export const BarcodeOrderStatusEnum = {
    NEW: 'new',
    ACCEPTED: 'accepted',
    SENT: 'sent',
    HAND_DELIVERY: 'hand_delivery',
    DONE: 'done',
    CANCELLED: 'cancelled',
} as const;
export type BarcodeOrderStatusEnum = (typeof BarcodeOrderStatusEnum)[keyof typeof BarcodeOrderStatusEnum];
export const BarcodeStockStatusEnum = {
    AVAILABLE: 'available',
    ASSIGNED: 'assigned',
    EXCLUDED: 'excluded',
} as const;
export type BarcodeStockStatusEnum = (typeof BarcodeStockStatusEnum)[keyof typeof BarcodeStockStatusEnum];
export const BookingStatusEnum = {
    DRAFT: 'draft',
    PENDING: 'pending',
    VALIDATED: 'validated',
    REFUSED: 'refused',
    FINISHED: 'finished',
    CANCELED: 'canceled',
} as const;
export type BookingStatusEnum = (typeof BookingStatusEnum)[keyof typeof BookingStatusEnum];
export const BrandConfigurationCheckGroupEnum = {
    PRODUCT: 'product',
    EQUIPMENT: 'equipment',
} as const;
export type BrandConfigurationCheckGroupEnum = (typeof BrandConfigurationCheckGroupEnum)[keyof typeof BrandConfigurationCheckGroupEnum];
export const CalendarResourceTypeEnum = {
    allotment: 'allotment',
    productTest: 'productTest',
    tour: 'tour',
} as const;
export type CalendarResourceTypeEnum = (typeof CalendarResourceTypeEnum)[keyof typeof CalendarResourceTypeEnum];
export const ConfigurationCheckerCheckImportanceEnum = {
    BLOCKING: 'blocking',
    IMPORTANT: 'important',
    ADVISED: 'advised',
} as const;
export type ConfigurationCheckerCheckImportanceEnum = (typeof ConfigurationCheckerCheckImportanceEnum)[keyof typeof ConfigurationCheckerCheckImportanceEnum];
export const ConfigurationCheckerCheckStatusEnum = {
    PASSED: 'passed',
    FAILED: 'failed',
    NOT_APPLICABLE: 'not_applicable',
} as const;
export type ConfigurationCheckerCheckStatusEnum = (typeof ConfigurationCheckerCheckStatusEnum)[keyof typeof ConfigurationCheckerCheckStatusEnum];
export const CurrencyEnum = {
    EUR: 'EUR',
    USD: 'USD',
    CAD: 'CAD',
    CHF: 'CHF',
    GBP: 'GBP',
} as const;
export type CurrencyEnum = (typeof CurrencyEnum)[keyof typeof CurrencyEnum];
export const DataRetentionReferenceDateEnum = {
    VALIDATED_AT: 'validated_at',
    LAST_PRODUCT_TEST: 'last_product_test',
    TOUR_END: 'tour_end',
    SUBSCRIPTION_END: 'subscription_end',
    LATEST_OF_ALL: 'latest_of_all',
} as const;
export type DataRetentionReferenceDateEnum = (typeof DataRetentionReferenceDateEnum)[keyof typeof DataRetentionReferenceDateEnum];
export const DepositBatchTypeEnum = {
    ALL_REGISTRATIONS: 'all_registrations',
    REGISTRATION_WITH_ORDER_ITEM: 'registration_with_order_item',
} as const;
export type DepositBatchTypeEnum = (typeof DepositBatchTypeEnum)[keyof typeof DepositBatchTypeEnum];
export const DepositStatusEnum = {
    PENDING: 'pending',
    VALIDATED: 'validated',
    RELEASED: 'released',
    CAPTURED: 'captured',
} as const;
export type DepositStatusEnum = (typeof DepositStatusEnum)[keyof typeof DepositStatusEnum];
export const DinSkierHeightEnum = {
    LessThan148: '148less',
    From149Toto157: '149to157',
    From158Toto166: '158to166',
    From167Toto178: '167to178',
    From179Toto194: '179to194',
    MoreThan195: '195more',
} as const;
export type DinSkierHeightEnum = (typeof DinSkierHeightEnum)[keyof typeof DinSkierHeightEnum];
export const DinSkierTypeEnum = {
    TYPE_I: 1,
    TYPE_II: 2,
    TYPE_III: 3,
} as const;
export type DinSkierTypeEnum = (typeof DinSkierTypeEnum)[keyof typeof DinSkierTypeEnum];
export const DinSkierWeightEnum = {
    From10to13: '10to13',
    From14to17: '14to17',
    From18to21: '18to21',
    From22to25: '22to25',
    From26to30: '26to30',
    From31to35: '31to35',
    From36to41: '36to41',
    From42to48: '42to48',
    From49to57: '49to57',
    From58to66: '58to66',
    From67to78: '67to78',
    From79to94: '79to94',
    moreThan95: '95more',
} as const;
export type DinSkierWeightEnum = (typeof DinSkierWeightEnum)[keyof typeof DinSkierWeightEnum];
export const EquipmentHealthStateEnum = {
    PERFECT: 'perfect',
    GOOD: 'good',
    AVERAGE: 'average',
    WATCH: 'watch',
    MAINTENANCE_REQUIRED: 'maintenance_required',
    UNUSABLE: 'unusable',
    AWAITING_PARTS: 'awaiting_parts',
} as const;
export type EquipmentHealthStateEnum = (typeof EquipmentHealthStateEnum)[keyof typeof EquipmentHealthStateEnum];
export const EquipmentStatusEnum = {
    COMMAND: 'command',
    IN_WAREHOUSE: 'in_warehouse',
    OUT_OF_WAREHOUSE: 'out_of_warehouse',
    UNDER_MAINTENANCE: 'under_maintenance',
    OUT_OF_ORDER: 'out_of_order',
    SOLD: 'sold',
    DESTROYED: 'destroyed',
} as const;
export type EquipmentStatusEnum = (typeof EquipmentStatusEnum)[keyof typeof EquipmentStatusEnum];
export const ExportPresetEnum = {
    BASIC: 'basic',
    ADVANCED: 'advanced',
    FULL: 'full',
} as const;
export type ExportPresetEnum = (typeof ExportPresetEnum)[keyof typeof ExportPresetEnum];
export const FiltersAsyncFilterModelEnum = {
    BRAND: 'Brand',
    EQUIPMENT_SIZE: 'EquipmentSize',
    PARK: 'Park',
    PRODUCT: 'Product',
    PRODUCT_TYPE: 'ProductType',
} as const;
export type FiltersAsyncFilterModelEnum = (typeof FiltersAsyncFilterModelEnum)[keyof typeof FiltersAsyncFilterModelEnum];
export const FiltersFilterDefinitionTypeEnum = {
    BOOLEAN: 'boolean',
    SELECT: 'select',
    ASYNC_SELECT: 'async_select',
    PERIOD: 'period',
    TEXT: 'text',
} as const;
export type FiltersFilterDefinitionTypeEnum = (typeof FiltersFilterDefinitionTypeEnum)[keyof typeof FiltersFilterDefinitionTypeEnum];
export const FormDefinitionsFormTypeEnum = {
    Radio: 'radio',
    Select: 'select',
} as const;
export type FormDefinitionsFormTypeEnum = (typeof FormDefinitionsFormTypeEnum)[keyof typeof FormDefinitionsFormTypeEnum];
export const GenderEnum = {
    WOMAN: 'woman',
    MAN: 'man',
    OTHER: 'other',
} as const;
export type GenderEnum = (typeof GenderEnum)[keyof typeof GenderEnum];
export const GtmLoadingModeEnum = {
    DIRECT: 'direct',
    BASIC: 'basic',
    ADVANCED: 'advanced',
} as const;
export type GtmLoadingModeEnum = (typeof GtmLoadingModeEnum)[keyof typeof GtmLoadingModeEnum];
export const ImportStatusEnum = {
    PENDING: 'pending',
    PROCESSING: 'processing',
    FAILED: 'failed',
    FINISH: 'finish',
    CANCELED: 'canceled',
} as const;
export type ImportStatusEnum = (typeof ImportStatusEnum)[keyof typeof ImportStatusEnum];
export const ImportStepEnum = {
    FORM: 'form',
    UPLOAD: 'upload',
    MATCHING: 'matching',
    PROCESS: 'process',
    REPORT: 'report',
    DOWNLOAD: 'download',
    DESTROY: 'destroy',
    CANCEL: 'cancel',
} as const;
export type ImportStepEnum = (typeof ImportStepEnum)[keyof typeof ImportStepEnum];
export const ImportsProductsAndEquipmentsEquipmentImportFieldEnum = {
    BARCODE: 'barcode',
    SIZE: 'size',
    COLOR: 'color',
    SERIAL_NUMBER: 'serial_number',
    REFERENCE: 'reference',
    COMMENT: 'comment',
} as const;
export type ImportsProductsAndEquipmentsEquipmentImportFieldEnum = (typeof ImportsProductsAndEquipmentsEquipmentImportFieldEnum)[keyof typeof ImportsProductsAndEquipmentsEquipmentImportFieldEnum];
export const ImportsProductsAndEquipmentsProductImportFieldEnum = {
    REFERENCE: 'reference',
    REFERENCE_ALIASES: 'reference_aliases',
    NAME: 'name',
    YEAR: 'year',
    DESCRIPTION: 'description',
    LINK: 'link',
} as const;
export type ImportsProductsAndEquipmentsProductImportFieldEnum = (typeof ImportsProductsAndEquipmentsProductImportFieldEnum)[keyof typeof ImportsProductsAndEquipmentsProductImportFieldEnum];
export const ImportsRegistrationsRegistrationDeduplicationStrategyEnum = {
    NONE: 'none',
    EMAIL: 'email',
    EMAIL_FIRSTNAME_LASTNAME: 'email_firstname_lastname',
    EMAIL_FIRSTNAME_LASTNAME_PHONE: 'email_firstname_lastname_phone',
} as const;
export type ImportsRegistrationsRegistrationDeduplicationStrategyEnum = (typeof ImportsRegistrationsRegistrationDeduplicationStrategyEnum)[keyof typeof ImportsRegistrationsRegistrationDeduplicationStrategyEnum];
export const InventoryEquipmentStatusEnum = {
    OUT: 'out',
    RETURNED: 'returned',
    MISSING: 'missing',
} as const;
export type InventoryEquipmentStatusEnum = (typeof InventoryEquipmentStatusEnum)[keyof typeof InventoryEquipmentStatusEnum];
export const InventoryStatusEnum = {
    OPEN: 'open',
    CLOSED: 'closed',
    ARCHIVED: 'archived',
} as const;
export type InventoryStatusEnum = (typeof InventoryStatusEnum)[keyof typeof InventoryStatusEnum];
export const LangEnum = {
    DE: 'de',
    EN: 'en',
    ES: 'es',
    FR: 'fr',
    IT: 'it',
    NL: 'nl',
    ZH: 'zh',
    JA: 'ja',
    CA: 'ca',
} as const;
export type LangEnum = (typeof LangEnum)[keyof typeof LangEnum];
export const MaintenanceStatusEnum = {
    PLANNED: 'planned',
    IN_PROGRESS: 'in_progress',
    DONE: 'done',
    BLOCKED: 'blocked',
} as const;
export type MaintenanceStatusEnum = (typeof MaintenanceStatusEnum)[keyof typeof MaintenanceStatusEnum];
export const MaintenanceTypeEnum = {
    INSPECTION: 'inspection',
    CLEANING: 'cleaning',
    MAINTENANCE: 'maintenance',
    ADJUSTMENT: 'adjustment',
    REPAIR: 'repair',
    PART_REPLACEMENT: 'part_replacement',
    SAFETY_CHECK: 'safety_check',
    SOFTWARE_UPDATE: 'software_update',
    DIAGNOSTIC: 'diagnostic',
    OTHER: 'other',
} as const;
export type MaintenanceTypeEnum = (typeof MaintenanceTypeEnum)[keyof typeof MaintenanceTypeEnum];
export const MarketingMessageChannelEnum = {
    EMAIL: 'email',
    SMS: 'sms',
} as const;
export type MarketingMessageChannelEnum = (typeof MarketingMessageChannelEnum)[keyof typeof MarketingMessageChannelEnum];
export const MarketingMessageEventEnum = {
    PUBLIC_REGISTRATION_DONE: 'publicRegistrationDone',
    EMAIL_CONFIRMED: 'emailConfirmed',
    REGISTRATION_VALIDATED: 'registrationValidated',
    REGISTRATION_BLOCKED: 'registrationBlocked',
    REGISTRATION_BARCODE_UPDATED: 'registrationBarcodeUpdated',
    PUBLIC_BOOKING_DONE: 'publicBookingDone',
    BOOKING_UPDATED: 'bookingUpdated',
    BOOKING_EXPECTED_START: 'bookingExpectedStart',
    BOOKING_EXPECTED_END: 'bookingExpectedEnd',
    PUBLIC_ORDER_DONE: 'publicOrderDone',
    NEW_ORDER_ITEM_BARCODE: 'newOrderItemBarcode',
    ORDER_CANCELLED: 'orderCancelled',
    DEPOSIT_CREATED: 'depositCreated',
    PAYMENT_SUCCESS: 'paymentSuccess',
    TEST_START: 'testStart',
    TEST_EXPECTED_END: 'testExpectedEnd',
    TEST_END: 'testEnd',
    PRODUCT_REVIEW_REQUEST: 'productReviewRequest',
    NEW_PRODUCT_REVIEW: 'newProductReview',
} as const;
export type MarketingMessageEventEnum = (typeof MarketingMessageEventEnum)[keyof typeof MarketingMessageEventEnum];
export const MarketingMessageMediaCollectionEnum = {
    HEADER: 'marketing-message-header',
    CONTENT: 'marketing-message-content',
    FOOTER: 'marketing-message-footer',
} as const;
export type MarketingMessageMediaCollectionEnum = (typeof MarketingMessageMediaCollectionEnum)[keyof typeof MarketingMessageMediaCollectionEnum];
export const MarketingMessageRecipientStatusEnum = {
    READY: 'ready',
    SCHEDULED: 'scheduled',
    SENT: 'sent',
    FAILED: 'failed',
    CANCELLED: 'cancelled',
} as const;
export type MarketingMessageRecipientStatusEnum = (typeof MarketingMessageRecipientStatusEnum)[keyof typeof MarketingMessageRecipientStatusEnum];
export const MarketingMessageScheduledTypeEnum = {
    DEFERRED: 'deferred',
    DEFERRED_WITH_REPETITION: 'deferredWithRepetition',
} as const;
export type MarketingMessageScheduledTypeEnum = (typeof MarketingMessageScheduledTypeEnum)[keyof typeof MarketingMessageScheduledTypeEnum];
export const MarketingMessageStatusEnum = {
    DRAFT: 'draft',
    READY: 'ready',
    IN_PROGRESS: 'inProgress',
    SENT: 'sent',
} as const;
export type MarketingMessageStatusEnum = (typeof MarketingMessageStatusEnum)[keyof typeof MarketingMessageStatusEnum];
export const MarketingMessageTypeEnum = {
    MANUAL: 'manual',
    AUTOMATIC: 'automatic',
    SCHEDULED: 'scheduled',
} as const;
export type MarketingMessageTypeEnum = (typeof MarketingMessageTypeEnum)[keyof typeof MarketingMessageTypeEnum];
export const MetafieldTypeEnum = {
    TEXT: 'text',
    SELECT: 'select',
} as const;
export type MetafieldTypeEnum = (typeof MetafieldTypeEnum)[keyof typeof MetafieldTypeEnum];
export const NotificationTypeEnum = {
    NEW_ONLINE_REGISTRATION: 'newOnlineRegistration',
    NEW_ONLINE_BOOKING: 'newOnlineBooking',
    TOUR_TEST_SUMMARY: 'tourTestSummary',
    PRODUCT_REVIEW_IN_REVIEW: 'productReviewInReview',
    PRODUCT_REVIEW_MODERATION_DIGEST: 'productReviewModerationDigest',
} as const;
export type NotificationTypeEnum = (typeof NotificationTypeEnum)[keyof typeof NotificationTypeEnum];
export const OrderAdjustmentTypeEnum = {
    PERCENTAGE_DISCOUNT: 'percentageDiscount',
    VALUE_DISCOUNT: 'valueDiscount',
} as const;
export type OrderAdjustmentTypeEnum = (typeof OrderAdjustmentTypeEnum)[keyof typeof OrderAdjustmentTypeEnum];
export const OrderStatusEnum = {
    CART: 'cart',
    NEW: 'new',
    CANCELLED: 'cancelled',
} as const;
export type OrderStatusEnum = (typeof OrderStatusEnum)[keyof typeof OrderStatusEnum];
export const OrganizationContactRoleEnum = {
    BILLING: 'billing',
    DATA_PROTECTION: 'data_protection',
    LEGAL: 'legal',
    TECHNICAL: 'technical',
    COMMERCIAL: 'commercial',
} as const;
export type OrganizationContactRoleEnum = (typeof OrganizationContactRoleEnum)[keyof typeof OrganizationContactRoleEnum];
export const OrganizationRecipientSourceEnum = {
    PRIMARY_CONTACT: 'primary_contact',
    FALLBACK: 'fallback',
    NOBODY: 'nobody',
} as const;
export type OrganizationRecipientSourceEnum = (typeof OrganizationRecipientSourceEnum)[keyof typeof OrganizationRecipientSourceEnum];
export const OrganizationSubscriptionStatusEnum = {
    ACTIVE: 'active',
    EXPIRING: 'expiring',
    EXPIRED: 'expired',
    UNLIMITED: 'unlimited',
} as const;
export type OrganizationSubscriptionStatusEnum = (typeof OrganizationSubscriptionStatusEnum)[keyof typeof OrganizationSubscriptionStatusEnum];
export const ParkTypeEnum = {
    HEADQUARTER: 'headquarter',
    LOCAL_ENTITY: 'local_entity',
    EVENT: 'event',
    RETAIL_STORE: 'retail_store',
    WAREHOUSE: 'warehouse',
    AMBASSADOR: 'ambassador',
    PRESS: 'press',
    OTHER: 'other',
} as const;
export type ParkTypeEnum = (typeof ParkTypeEnum)[keyof typeof ParkTypeEnum];
export const PaymentModeEnum = {
    STRIPE: 'stripe',
    BRAINTREE: 'braintree',
    CASH: 'cash',
    CHECK: 'check',
    CARD: 'card',
    FREE: 'free',
    DUMMY: 'dummy',
} as const;
export type PaymentModeEnum = (typeof PaymentModeEnum)[keyof typeof PaymentModeEnum];
export const PaymentProviderStatusEnum = {
    NOT_CONFIGURED: 'not_configured',
    WEBHOOK_MISSING: 'webhook_missing',
    CONFIGURED: 'configured',
} as const;
export type PaymentProviderStatusEnum = (typeof PaymentProviderStatusEnum)[keyof typeof PaymentProviderStatusEnum];
export const PaymentProviderTypeEnum = {
    STRIPE: 'stripe',
    BRAINTREE: 'braintree',
    DUMMY: 'dummy',
} as const;
export type PaymentProviderTypeEnum = (typeof PaymentProviderTypeEnum)[keyof typeof PaymentProviderTypeEnum];
export const PaymentStatusEnum = {
    CREATED: 'created',
    PROCESSING: 'processing',
    REQUIRES_CAPTURE: 'requires_capture',
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    CANCELED: 'canceled',
} as const;
export type PaymentStatusEnum = (typeof PaymentStatusEnum)[keyof typeof PaymentStatusEnum];
export const PaymentTypeEnum = {
    DEBIT: 'debit',
    AUTHORISATION: 'authorisation',
} as const;
export type PaymentTypeEnum = (typeof PaymentTypeEnum)[keyof typeof PaymentTypeEnum];
export const PdfTemplateTypeEnum = {
    TICKET: 'ticket',
    TESTER_CARD: 'tester_card',
} as const;
export type PdfTemplateTypeEnum = (typeof PdfTemplateTypeEnum)[keyof typeof PdfTemplateTypeEnum];
export const PermissionsAbilitiesExponentAbilityEnum = {
    SETUP: 'setup',
    PRODUCTS: 'products',
} as const;
export type PermissionsAbilitiesExponentAbilityEnum = (typeof PermissionsAbilitiesExponentAbilityEnum)[keyof typeof PermissionsAbilitiesExponentAbilityEnum];
export const PermissionsAbilitiesOrganizationAbilityEnum = {
    SETUP: 'setup',
    TOUR: 'tour',
    EXPONENT: 'exponent',
    PAYMENT_PROVIDER: 'payment-provider',
    WEBHOOK: 'webhook',
} as const;
export type PermissionsAbilitiesOrganizationAbilityEnum = (typeof PermissionsAbilitiesOrganizationAbilityEnum)[keyof typeof PermissionsAbilitiesOrganizationAbilityEnum];
export const PermissionsAbilitiesParkAbilityEnum = {
    EDIT: 'edit',
} as const;
export type PermissionsAbilitiesParkAbilityEnum = (typeof PermissionsAbilitiesParkAbilityEnum)[keyof typeof PermissionsAbilitiesParkAbilityEnum];
export const PermissionsAbilitiesStageAbilityEnum = {
    EDIT: 'edit',
    REGISTRATION: 'registration',
    PRODUCT_TEST: 'productTest',
    BOOKING: 'booking',
} as const;
export type PermissionsAbilitiesStageAbilityEnum = (typeof PermissionsAbilitiesStageAbilityEnum)[keyof typeof PermissionsAbilitiesStageAbilityEnum];
export const PermissionsAbilitiesStoreAbilityEnum = {
    EDIT: 'edit',
    REGISTRATION: 'registration',
    PRODUCT_TEST: 'productTest',
    BOOKING: 'booking',
} as const;
export type PermissionsAbilitiesStoreAbilityEnum = (typeof PermissionsAbilitiesStoreAbilityEnum)[keyof typeof PermissionsAbilitiesStoreAbilityEnum];
export const PermissionsAbilitiesTourAbilityEnum = {
    SETUP: 'setup',
    REGISTRATION: 'registration',
    PRODUCT_VIEW: 'productsShow',
    PRODUCT_TEST: 'productTest',
    STATISTICS: 'stats',
    REVIEW: 'review',
    MARKETING_CREATE: 'marketing:create',
    MARKETING_SEND: 'marketing:send',
    BOOKING: 'booking',
    BOOKING_VIEW: 'booking:view',
    ORDER_VIEW: 'order:view',
    ORDER_UPDATE: 'order:update',
    PAYMENT_VIEW: 'payment:view',
    PAYMENT_UPDATE: 'payment:update',
} as const;
export type PermissionsAbilitiesTourAbilityEnum = (typeof PermissionsAbilitiesTourAbilityEnum)[keyof typeof PermissionsAbilitiesTourAbilityEnum];
export const PriceDisplayModeEnum = {
    TAX_INCLUDED: 'tax_included',
    TAX_EXCLUDED: 'tax_excluded',
} as const;
export type PriceDisplayModeEnum = (typeof PriceDisplayModeEnum)[keyof typeof PriceDisplayModeEnum];
export const ProcessingQueueEnum = {
    PAYMENT_REFRESH: 'paymentRefresh',
    MARKETING_MESSAGE_RECIPIENT: 'marketingMessageRecipient',
    EXPORT: 'export',
    THIRD_PARTY: 'thirdParty',
    MEDIA_LIBRARY_MIGRATION: 'mediaLibraryMigration',
    REVIEW_MODERATION: 'reviewModeration',
    WEBHOOK: 'webhook',
} as const;
export type ProcessingQueueEnum = (typeof ProcessingQueueEnum)[keyof typeof ProcessingQueueEnum];
export const ProductReviewModerationOutcomeEnum = {
    PASSED: 'passed',
    CORRECTED: 'corrected',
    FLAGGED: 'flagged',
    ERRORED: 'errored',
} as const;
export type ProductReviewModerationOutcomeEnum = (typeof ProductReviewModerationOutcomeEnum)[keyof typeof ProductReviewModerationOutcomeEnum];
export const ProductReviewModerationStepEnum = {
    QUALITY: 'quality',
    FORBIDDEN_WORDS: 'forbidden_words',
    PERSONAL_DATA: 'personal_data',
    LANGUAGE: 'language',
    CONTENT_RELEVANCE: 'content_relevance',
} as const;
export type ProductReviewModerationStepEnum = (typeof ProductReviewModerationStepEnum)[keyof typeof ProductReviewModerationStepEnum];
export const ProductReviewStatusEnum = {
    CREATED: 'created',
    IN_REVIEW: 'in_review',
    VALIDATED: 'validated',
    REJECTED: 'rejected',
} as const;
export type ProductReviewStatusEnum = (typeof ProductReviewStatusEnum)[keyof typeof ProductReviewStatusEnum];
export const ProductTestConditionsOperationEnum = {
    CONTAINS: 'contains',
    NOT_CONTAINS: 'notContains',
} as const;
export type ProductTestConditionsOperationEnum = (typeof ProductTestConditionsOperationEnum)[keyof typeof ProductTestConditionsOperationEnum];
export const ProductTestConditionsRuleTypeEnum = {
    ALLOW: 'allow',
    DISALLOW: 'disallow',
} as const;
export type ProductTestConditionsRuleTypeEnum = (typeof ProductTestConditionsRuleTypeEnum)[keyof typeof ProductTestConditionsRuleTypeEnum];
export const ProductTestStatusEnum = {
    IN_PROGRESS: 'in_progress',
    LATE: 'late',
    FINISHED: 'finished',
} as const;
export type ProductTestStatusEnum = (typeof ProductTestStatusEnum)[keyof typeof ProductTestStatusEnum];
export const ProductsAndEquipmentsImportTypeEnum = {
    BOTH: 'both',
    PRODUCT: 'product',
    EQUIPMENT: 'equipment',
} as const;
export type ProductsAndEquipmentsImportTypeEnum = (typeof ProductsAndEquipmentsImportTypeEnum)[keyof typeof ProductsAndEquipmentsImportTypeEnum];
export const RegistrationCompanyDeduplicationRuleEnum = {
    COMPANY_NAME: 'company_name',
    COMPANY_NAME_ZIPCODE: 'company_name_zipcode',
    COMPANY_NAME_CITY: 'company_name_city',
    COMPANY_NAME_ZIPCODE_CITY: 'company_name_zipcode_city',
    COMPANY_NAME_ADDRESS_CITY: 'company_name_address_city',
    COMPANY_NAME_ADDRESS_ZIPCODE: 'company_name_address_zipcode',
    COMPANY_NAME_ADDRESS_ZIPCODE_CITY: 'company_name_address_zipcode_city',
} as const;
export type RegistrationCompanyDeduplicationRuleEnum = (typeof RegistrationCompanyDeduplicationRuleEnum)[keyof typeof RegistrationCompanyDeduplicationRuleEnum];
export const RegistrationConditionEffectEnum = {
    SHOW: 'show',
    REQUIRE: 'require',
} as const;
export type RegistrationConditionEffectEnum = (typeof RegistrationConditionEffectEnum)[keyof typeof RegistrationConditionEffectEnum];
export const RegistrationConditionOperationEnum = {
    EQUALS: 'equals',
    NOT_EQUALS: 'notEquals',
    AGE_UNDER: 'ageUnder',
    AGE_AT_LEAST: 'ageAtLeast',
} as const;
export type RegistrationConditionOperationEnum = (typeof RegistrationConditionOperationEnum)[keyof typeof RegistrationConditionOperationEnum];
export const RegistrationContextEnum = {
    backoffice: 'backoffice',
    frontoffice: 'public',
    api: 'mobileApp',
    validation: 'validation',
    import: 'import',
} as const;
export type RegistrationContextEnum = (typeof RegistrationContextEnum)[keyof typeof RegistrationContextEnum];
export const RegistrationExtrafieldTypeEnum = {
    TEXT: 'text',
    SELECT: 'select',
    CHECKBOX: 'simple-checkbox',
    MULTI_CHECKBOX: 'checkbox',
    SIGNATURE: 'signature',
} as const;
export type RegistrationExtrafieldTypeEnum = (typeof RegistrationExtrafieldTypeEnum)[keyof typeof RegistrationExtrafieldTypeEnum];
export const RegistrationRegistrationFieldEnum = {
    GENDER: 'gender',
    FIRSTNAME: 'firstname',
    LASTNAME: 'lastname',
    BIRTHDAY: 'birthday',
    EMAIL: 'email',
    PASSWORD: 'password',
    PHONE: 'phone',
    COMPANY: 'company',
    ADDRESS: 'address',
    CITY: 'city',
    ZIPCODE: 'zipcode',
    COUNTRY: 'country',
    LANG: 'lang',
    STAGE: 'stage',
    STORE: 'store',
    GROUP: 'group',
    PROMO_EVENT: 'promo_event',
    BARCODE: 'barcode',
    AVATAR: 'avatar',
    PROOF_OF_IDENTITIES: 'proofOfIdentities',
    SIGNATURE: 'signature',
    DIN: 'din',
    COMMENT: 'comment',
    CGU: 'cgu',
    DEPOSIT: 'deposit',
} as const;
export type RegistrationRegistrationFieldEnum = (typeof RegistrationRegistrationFieldEnum)[keyof typeof RegistrationRegistrationFieldEnum];
export const RegistrationStatusEnum = {
    DRAFT: 'draft',
    REGISTERED: 'registered',
    VALIDATED: 'validated',
    BLOCKED: 'blocked',
} as const;
export type RegistrationStatusEnum = (typeof RegistrationStatusEnum)[keyof typeof RegistrationStatusEnum];
export const ReviewCriteriaTypeEnum = {
    RATING: 'rating',
    SELECT: 'select',
    CHECKBOX: 'checkbox',
    TEXT: 'text',
    TEXTAREA: 'textarea',
    UPLOAD: 'upload',
} as const;
export type ReviewCriteriaTypeEnum = (typeof ReviewCriteriaTypeEnum)[keyof typeof ReviewCriteriaTypeEnum];
export const ServicesDnsZoneEnum = {
    main: 'main',
    alias: 'alias',
} as const;
export type ServicesDnsZoneEnum = (typeof ServicesDnsZoneEnum)[keyof typeof ServicesDnsZoneEnum];
export const ServicesPaymentBraintreeEnvironmentEnum = {
    Sandbox: 'sandbox',
    Production: 'production',
} as const;
export type ServicesPaymentBraintreeEnvironmentEnum = (typeof ServicesPaymentBraintreeEnvironmentEnum)[keyof typeof ServicesPaymentBraintreeEnvironmentEnum];
export const ServicesPaymentStripeEnvironmentEnum = {
    Live: 'live',
    Test: 'test',
} as const;
export type ServicesPaymentStripeEnvironmentEnum = (typeof ServicesPaymentStripeEnvironmentEnum)[keyof typeof ServicesPaymentStripeEnvironmentEnum];
export const ServicesThirdPartyEnvironmentEnum = {
    STAGING: 'staging',
    PRODUCTION: 'prod',
} as const;
export type ServicesThirdPartyEnvironmentEnum = (typeof ServicesThirdPartyEnvironmentEnum)[keyof typeof ServicesThirdPartyEnvironmentEnum];
export const ServicesThirdPartyProvidersBazaarvoiceSdkEnvironmentEnum = {
    staging: 'staging',
    production: 'prod',
} as const;
export type ServicesThirdPartyProvidersBazaarvoiceSdkEnvironmentEnum = (typeof ServicesThirdPartyProvidersBazaarvoiceSdkEnvironmentEnum)[keyof typeof ServicesThirdPartyProvidersBazaarvoiceSdkEnvironmentEnum];
export const ServicesThirdPartyProvidersJudgeMePlatformEnum = {
    SHOPIFY: 'shopify',
    WOOCOMMERCE: 'woocommerce',
    BIGCOMMERCE: 'bigcommerce',
} as const;
export type ServicesThirdPartyProvidersJudgeMePlatformEnum = (typeof ServicesThirdPartyProvidersJudgeMePlatformEnum)[keyof typeof ServicesThirdPartyProvidersJudgeMePlatformEnum];
export const ServicesThirdPartyProvidersOpenvoiceEnvironmentEnum = {
    preprod: 'preprod',
    production: 'prod',
} as const;
export type ServicesThirdPartyProvidersOpenvoiceEnvironmentEnum = (typeof ServicesThirdPartyProvidersOpenvoiceEnvironmentEnum)[keyof typeof ServicesThirdPartyProvidersOpenvoiceEnvironmentEnum];
export const ServicesThirdPartyServiceEnum = {
    BAZAARVOICE: 'bazaarvoice',
    GTS_IMPORT: 'GtsImport',
    JUDGE_ME: 'judgeme',
    OPENVOICE: 'openvoice',
    SHOPIFY: 'shopify',
    YOTPO: 'yotpo',
} as const;
export type ServicesThirdPartyServiceEnum = (typeof ServicesThirdPartyServiceEnum)[keyof typeof ServicesThirdPartyServiceEnum];
export const StatusEnum = {
    PENDING: 'pending',
    CREATED: 'created',
    ERROR: 'error',
} as const;
export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
export const SubscriptionLimitEnforcementEnum = {
    HARD: 'hard',
    SOFT: 'soft',
} as const;
export type SubscriptionLimitEnforcementEnum = (typeof SubscriptionLimitEnforcementEnum)[keyof typeof SubscriptionLimitEnforcementEnum];
export const SubscriptionSubscriptionMetricEnum = {
    TOURS: 'tours',
    REGISTRATIONS: 'registrations',
    EXPONENTS: 'exponents',
    EQUIPMENTS: 'equipments',
} as const;
export type SubscriptionSubscriptionMetricEnum = (typeof SubscriptionSubscriptionMetricEnum)[keyof typeof SubscriptionSubscriptionMetricEnum];
export const SubscriptionSubscriptionTypeEnum = {
    TRIAL: 'trial',
    FREE: 'free',
    PAID: 'paid',
    INTERNAL: 'internal',
} as const;
export type SubscriptionSubscriptionTypeEnum = (typeof SubscriptionSubscriptionTypeEnum)[keyof typeof SubscriptionSubscriptionTypeEnum];
export const TermTypeEnum = {
    USER: 'user',
    ORGANIZATION: 'organization',
    DPA: 'dpa',
} as const;
export type TermTypeEnum = (typeof TermTypeEnum)[keyof typeof TermTypeEnum];
export const TourConfigurationCheckGroupEnum = {
    GENERAL: 'general',
    WEBSITE: 'website',
    PARTICIPANTS: 'participants',
    EXHIBITORS: 'exhibitors',
    BOOKING: 'booking',
    ECOMMERCE: 'ecommerce',
    COMMUNICATION: 'communication',
} as const;
export type TourConfigurationCheckGroupEnum = (typeof TourConfigurationCheckGroupEnum)[keyof typeof TourConfigurationCheckGroupEnum];
export const TourConfigurationScenarioEnum = {
    REGISTRATION_ONLY: 'registration_only',
    WITH_BOOKING: 'with_booking',
    WITH_FREE_ACTIVITIES: 'with_free_activities',
    WITH_PAID_ACTIVITIES: 'with_paid_activities',
} as const;
export type TourConfigurationScenarioEnum = (typeof TourConfigurationScenarioEnum)[keyof typeof TourConfigurationScenarioEnum];
export const TourDuplicationFieldEnum = {
    REGISTRATION_FORMS: 'registrationForms',
    USERS: 'users',
    EXPONENTS: 'exponents',
    MARKETING_MESSAGES: 'marketingMessages',
    TAX_RATES: 'taxRates',
    ACTIVITY_OPTIONS: 'activityOptions',
    ACTIVITIES: 'activities',
} as const;
export type TourDuplicationFieldEnum = (typeof TourDuplicationFieldEnum)[keyof typeof TourDuplicationFieldEnum];
export const TourExponentStatusEnum = {
    AWAITING: 'awaiting',
    PARTIAL: 'partial',
    READY: 'ready',
} as const;
export type TourExponentStatusEnum = (typeof TourExponentStatusEnum)[keyof typeof TourExponentStatusEnum];
export const UserInvitationStatusEnum = {
    PENDING: 'pending',
    EXPIRED: 'expired',
    ACCEPTED: 'accepted',
    REVOKED: 'revoked',
} as const;
export type UserInvitationStatusEnum = (typeof UserInvitationStatusEnum)[keyof typeof UserInvitationStatusEnum];
export const UserStatusEnum = {
    ACTIVE: 'active',
    PENDING_INVITATION: 'pending_invitation',
} as const;
export type UserStatusEnum = (typeof UserStatusEnum)[keyof typeof UserStatusEnum];
export const WebhookDeliveryStatusEnum = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    FAILED_PERMANENTLY: 'failed_permanently',
} as const;
export type WebhookDeliveryStatusEnum = (typeof WebhookDeliveryStatusEnum)[keyof typeof WebhookDeliveryStatusEnum];
export const WebhookEventTypeEnum = {
    REGISTRATION_CREATED: 'registration.created',
    REGISTRATION_UPDATED: 'registration.updated',
    REGISTRATION_DELETED: 'registration.deleted',
    PRODUCT_TEST_FINISHED: 'product_test.finished',
} as const;
export type WebhookEventTypeEnum = (typeof WebhookEventTypeEnum)[keyof typeof WebhookEventTypeEnum];
